exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-documents-table-wrapper {\n  margin: 10px;\n}\ntable.action-documents-table tr:first-child td, table.action-documents-table tr:first-child th {\n  text-align: left;\n  border-top: none;\n}\ntable.action-documents-table td, table.action-documents-table th {\n  padding-left: 0px !important;\n}\n.table-heading {\n  width: 100%;\n}\n", ""]);

// exports
